<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" :id="id">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <TablerIcon name="IconPencil" />
                        <span v-if="editor.id">ショップメニュー編集</span>
                        <span v-else>新規ショップメニュー作成</span>
                    </h4>
                </div>
                <div class="modal-body">
                    <div>
                        <label>ショップメニュー名</label>
                        <input type="text" v-model="editor.menu_name" class="form-control" placeholder="メニュー名" v-on:keyup.ctrl.enter="save(editor)">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">閉じる</button>
                    <button type="button" class="btn btn-primary" v-on:click="save(editor)">保存(Ctrl+Enter)</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            default: 'shop-menus-editor'
        },
        shop_menu_id: {},
    },
    data() {
        return {
            editor: {},
        }
    },
    methods: {
        // 保存
        save(editor) {
            axios.post("/master/shop_menus/save", this.editor).then(res => {
                Alert.msg(res.data);
                $(`#${this.id}`).modal("hide");
                this.$emit('save');
            }).catch(err => { Alert.err(err) });
        },
    },
    mounted() {
        // 編集モーダルが開かれた場合
        $(`#${this.id}`).on("show.bs.modal", (e) => {
            // 編集の場合、該当データを取得
            if (this.shop_menu_id) {
                axios.get("/master/shop_menus/edit", { params: {id: this.shop_menu_id}}).then(res => {
                    let rc = res.data;
                    if (Object.keys(rc).length) {
                        this.editor = rc;
                    }
                }).catch(err => {
                    // 該当データが存在しない場合、編集モーダルを非表示
                    Alert.err("該当レコードは存在しません");
                    $(`#${this.id}`).modal("hide");
                    this.$emit('save');
                });
            // 新規追加の場合、項目を空にする
            } else {
                this.editor = {};
            }
        });
        $(`#${this.id}`).on("hide.bs.modal", (e) => {
            this.$emit("close");
        });
        this.$emit("mounted", this.id);
    }

}
</script>
